<template>
  <div class="work_code_cla">
    <div class="header-button-bar">
      <el-button
        v-if="showAdd"
        @click.stop="AddItem"
        type="primary"
        >{{ $t('common.add') }}</el-button
      >
      <el-button
        v-if="tableData.length > 0"
        @click.stop="deleteAll"
        type="danger"
        >{{ $t('common.delete') }}</el-button
      >
    </div>
    <el-table
      :highlight-current-row="true"
      @selection-change="selectionChange"
      ref="singleTable"
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column property="code" :label="this.$t('device.code')">
        <template slot-scope="scope">
          <template v-if="scope.row.idEdit">
            <el-input
              :disabled="scope.row.id !== ''"
              v-model="scope.row.code"
              :placeholder="$t('common.enterValue')"
            ></el-input>
          </template>
          <template v-else>
            <span>{{ scope.row.code }}</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column property="codeName" :label="this.$t('common.Label')">
        <template slot-scope="scope">
          <template v-if="scope.row.idEdit">
            <el-input
              v-model="scope.row.codeName"
              :placeholder="$t('common.enterValue')"
            ></el-input>
          </template>
          <template v-else>
            <span>{{ scope.row.codeName }}</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column :label="this.$t('common.action')">
        <template slot-scope="scope">
          <template v-if="scope.row.idEdit">
            <ZkButtonGroup
              :showTip="true"
              :params="scope.row"
              :showText="false"
              @editWorkCode="editRow(scope.row)"
              @saveWorkCode="saveItem(scope.row)"
              @deleteWorkCode="deleteRow(scope.$index, scope.row)"
              :event="['saveWorkCode', 'deleteWorkCode']"
              size="mini"
              groupName="enterprise_attendanceCode_right"
              :isGroup="true"
            ></ZkButtonGroup>
          </template>
          <template v-else>
            <ZkButtonGroup
              :showTip="true"
              :params="scope.row"
              :showText="false"
              @editWorkCode="editRow(scope.row)"
              @saveWorkCode="saveItem(scope.row)"
              @deleteWorkCode="deleteRow(scope.$index, scope.row)"
              :event="['editWorkCode', 'deleteWorkCode']"
              size="mini"
              groupName="enterprise_attendanceCode_right"
              :isGroup="true"
            ></ZkButtonGroup>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  findWorkCode,
  saveOrUpdateWorkCode,
  batchDeleteWorkCode
} from '@/services/workcodeApi.js'
export default {
  data() {
    return {
      showAdd: true,
      workCodeList: [],
      tableData: [],
      tableCheck: []
    }
  },
  watch: {
    selectAttCode: {
      handler(newValue, oldValue) {
        this.showAdd = true
        if (newValue) {
          this.tableData = []
          this.queryWorkCode()
        }
      },
      deep: true
    }
  },
  props: {
    selectAttCode: {
      type: Object,
      function() {
        return {}
      }
    }
  },
  mounted() {
    this.tableData = []
    this.queryWorkCode()
  },
  methods: {
    deleteAll() {
      if (this.tableCheck.length < 1) {
        this.$message({
          type: 'error',
          message: this.$t('common.selectRecod')
        })
        return false
      }
      let _this = this
      this.$confirm(
        this.$t('common.confirmDeleteRecordTip'),
        this.$t('common.warningNotice'),
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          let ids = _this.tableCheck.map((item) => {
            return item.id
          })
          _this.deleteWorkCode(ids)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelOperation')
          })
        })
    },
    selectionChange(selection) {
      this.tableCheck = selection
    },
    editRow(row) {
      this.tableData.forEach((item) => {
        item.idEdit = false
      })
      row.idEdit = true
    },
    deleteRow(index, row) {
      if (!row.id) {
        this.showAdd = true
        this.tableData.splice(index, 1)
      } else {
        this.$confirm(
          this.$t('common.confirmDeleteRecordTip'),
          this.$t('common.warningNotice'),
          {
            confirmButtonText: this.$t('common.confirm'),
            cancelButtonText: this.$t('common.cancel'),
            type: 'warning'
          }
        )
          .then(() => {
            this.deleteWorkCode([row.id])
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('common.cancelOperation')
            })
          })
      }
    },
    deleteWorkCode(ids) {
      let params = {
        ids: ids
      }
      batchDeleteWorkCode(params)
        .then((data) => {
          if (data.code === '00000000') {
            this.queryWorkCode()
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch((data) => {
          this.errorMessage()
        })
    },
    saveType() {
      let params = {
        workCodeList: this.tableData
      }
      saveOrUpdateWorkCode(params)
        .then((data) => {
          if (data.code === '00000000') {
            this.queryWorkCode()
            this.showAdd = true
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch((data) => {
          this.errorMessage()
        })
    },
    saveItem(row) {
      if (!row.code) {
        this.$notify.error({
          title: this.$t('common.notice'),
          message: this.$t('attendanceCode.requireLaborCodes')
        })
        return false
      }
      if (!row.codeName) {
        this.$notify.error({
          title: this.$t('common.notice'),
          message: this.$t('attendanceCode.requireLaborCodesName')
        })
        return false
      }

      let params = {
        workCodeList: [row]
      }
      saveOrUpdateWorkCode(params)
        .then((data) => {
          if (data.code === '00000000') {
            row.idEdit = false
            this.showAdd = true
            this.queryWorkCode()
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch((data) => {
          this.errorMessage()
        })
    },
    AddItem() {
      this.tableData.push({
        idEdit: true,
        id: '',
        typeId: this.selectAttCode.id,
        code: '',
        codeName: ''
      })
      this.showAdd = false
    },
    queryWorkCode() {
      let params = {
        typeId: this.selectAttCode.id
      }
      findWorkCode(params)
        .then((data) => {
          if (data.code === '00000000') {
            this.tableData = []
            let result = data.payload.results.workCodeList
            let len = result.length
            for (let i = 0; i < len; i++) {
              result[i].idEdit = false
              this.tableData.push(result[i])
            }
          } else {
            this.tableData = []
          }
        })
        .catch((data) => {
          this.errorMessage()
        })
    }
  }
}
</script>
<style scoped lang="less">
.work_code_cla {
  margin-top:12px;
 // .icon_cla {
  //   margin: 0px 10px;
  //   cursor: pointer;
  // }
  // .icon_delete_cla {
  //   color: red;
  // }
  // .button_bar_cla {
  //   padding-top: 15px;
  //   float: right;
  // }
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/enterpriseSetting/attendanceCode/workCodeInfo.vue